import { Cell } from 'react-table';
import { DownloadLink } from './DownloadDiagnosticsStyled';
import { Export } from 'components/Icons';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { axiosClient } from 'api/axiosClient';
import { routes } from 'routes';

export const DownloadDiagnostics = () => {
  const [dataEnvironment] = useDataEnvironment();

  return ({ row }: Cell) => {
    const values = row.values;

    function downloadHandler(id: string) {
      axiosClient
        .get(routes.getDownloadDiagnostics(id, dataEnvironment?.id), {
          responseType: 'blob',
        })
        .then((response) => {
          let blob = new Blob([response.data], { type: 'application/zip' }),
            url = window.URL.createObjectURL(blob);

          var a: any = document.createElement('A');
          a.href = url;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
    }

    return (
      <DownloadLink onClick={() => downloadHandler(values.id)}>
        {values.status !== 'Running' ? (
          <>
            <Export size='14px' />
            <span>Download Diagnostics</span>
          </>
        ) : null}
      </DownloadLink>
    );
  };
};
